import styled, { css } from 'styled-components';

export const NavLinksList = styled.ul`
  ${({ theme }) => css`
    list-style-type: none;
    padding: 0;
    margin: 0;

    // styling for the first and last children of the NavLink component
    .mantine-NavLink-children & {
      li:first-child a,
      button {
        margin-top: ${theme.spacing(1)};
      }
      li:last-child a,
      button {
        margin-bottom: ${theme.spacing(1)};
      }
      li:last-child ::after {
        display: none;
      }
      li:first-child ::before {
        border-radius: 3px 3px 0px 0px;
      }
      li:first-child:last-child ::before {
        border-radius: 3px 3px 3px 3px;
      }
      li:last-child ::before {
        border-radius: 0px 0px 3px 3px;
      }
      li:last-child ::after {
        display: none;
      }
    }
  `}
`;
